"use strict";
/*
 * Created on Thu Nov 08 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var utils_1 = require("../../core/utils");

var LockTypeEnum_1 = require("../../product/model/LockTypeEnum");

var UserInfo_1 = require("../../user/model/UserInfo");

var CoordinatorFlags_1 = require("./CoordinatorFlags");

var CreationSource_1 = require("./CreationSource");

var MemberCredits_1 = require("./MemberCredits");

var PosTypeEnum_1 = require("./PosTypeEnum");

var WindowItemPosAttributes_1 = require("./WindowItemPosAttributes");

var WindowItemSimulation_1 = require("./WindowItemSimulation");

var WindowItemSitesData_1 = require("./WindowItemSitesData");

var WindowItemWarningFlag_1 = require("./WindowItemWarningFlag");
/**
 * @author JMt
 */


var WindowItem =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(WindowItem, _StateDomainObject_1$);

  /**
   * Creates new object of windowItem.
   *
   * @param id the id of windowItem
   * @param productId id of associated product
   * @param windowId id of associated window
   * @param externalId - combination of ids promotion.externalId:product.externalId
   * @param promotionId promotion identifier
   * @param promoPrice - user input price default value is regular price with VAT
   * @param regularPrice with VAT
   * @param optRegularPrice - regular price from promo optimization
   * @param cmForecast - estimate of quantity sold by category manager
   * @param systemVolume - value from promo optimization
   * @param lastSystemVolumeUpdate - timestamp when promoOptAPI return systemVolume value, override itself after every call
   * @param promoVolume - value from user - default systemVolume value
   * @param regularVolume - value from weekly baseline
   * @param requestSecondaryPlacement - if true secondaryPlacement values
   * @param secondaryPlacement - values from space_planning IDB table
   * @param posAttributes - contains values used in pos mechanics
   * @param memberCredits - contains values for Promo4Member and Promo4Healthy credits
   * @param logisticComment - user input string
   * @param returnable - if true product is possible to return back to supplier
   * @param returnableCondition - specifications of returnable
   * @param endDateOfReturn - day of last possible return
   * @param distrModelId - options delivery for product (values in codebook distribution model, external id in config)
   * @param lastDistrModelIdChangeTime - for GLSR variant (LOG-5394) - last time when user changed {@link WindowItem.distrModelId},
   * null when never
   * @param lastDistrModelIdChangeUser - for GLSR variant (LOG-5394) - last user that changed {@link WindowItem.distrModelId},
   * null when no one
   * @param distributionModelDays - number of days for certain distribution model options - user input
   * @param lockType - enum (all pre-deliveries, all deliveries), default value is all pre-deliveries
   * @param selloutSales TODO doc
   * @param ignoreForTraining
   * @param activeSale
   * @param extraSaleSticker TODO doc
   * @param tastings TODO doc
   * @param tvCommercial - if true product is mentioned in TV
   * @param groupOfSitesId internal GoS id where product will be sold during promotion (default value same os promo GoS)
   * @param sitesData encapsulated sites data
   * @param onPicture - defines if product has picture in paper leaflet
   * @param stateFlags
   * @param classification TODO doc
   * @param warningFlags - validation results
   * @param substituteProductId TODO doc
   * @param marketingComment
   * @param directDelivery If item has direct delivery.
   * @param directDeliverySites GoS set only if direct delivery is true
   * @param simulation - Contains values that are simulated. Will exist when the forecast simulation is created.
   * @param measureUnits
   * @param justInTime TODO doc
   * @param processed defines whether an instance was processed (used primarily for import)
   * @param lastPromoVolumeUpdate moment of last promo volume update by user
   * @param lastSystemVolumeComputationFailure
   * @param forecastCoordinatorFlag - flag object used for coordinator role
   * @param snapshotOriginId string | null
   * @param source
   */
  function WindowItem(id, productId, windowId, externalId, // LOG-3050
  promotionId, // LOG-4311
  promoPrice, regularPrice, optRegularPrice, cmForecast, // TODO ZSt BigDecimal
  systemVolume, lastSystemVolumeUpdate, promoVolume, regularVolume, requestSecondaryPlacement, secondaryPlacement, posAttributes, memberCredits, logisticComment, returnable, returnableCondition, endDateOfReturn, distrModelId, lastDistrModelIdChangeTime, lastDistrModelIdChangeUser, distributionModelDays, lockType, selloutSales, ignoreForTraining, activeSale, extraSaleSticker, tastings, tvCommercial, groupOfSitesId, sitesData, onPicture, stateFlags, classification, warningFlags, substituteProductId, marketingComment, directDelivery, directDeliverySites, measureUnits, simulation, justInTime, processed, lastPromoVolumeUpdate, lastSystemVolumeComputationFailure, forecastCoordinatorFlag) {
    var _this;

    var snapshotOriginId = arguments.length > 49 && arguments[49] !== undefined ? arguments[49] : null;
    var source = arguments.length > 50 && arguments[50] !== undefined ? arguments[50] : CreationSource_1.CreationSource.NOT_AVAILABLE;

    _classCallCheck(this, WindowItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItem).call(this, stateFlags));
    _this.id = id;
    _this.productId = productId;
    _this.windowId = windowId;
    _this.externalId = externalId;
    _this.promotionId = promotionId;
    _this.promoPrice = promoPrice;
    _this.regularPrice = regularPrice;
    _this.optRegularPrice = optRegularPrice;
    _this.cmForecast = cmForecast;
    _this.systemVolume = systemVolume;
    _this.lastSystemVolumeUpdate = lastSystemVolumeUpdate;
    _this.promoVolume = promoVolume;
    _this.regularVolume = regularVolume;
    _this.requestSecondaryPlacement = requestSecondaryPlacement;
    _this.secondaryPlacement = secondaryPlacement;
    _this.posAttributes = posAttributes;
    _this.memberCredits = memberCredits;
    _this.logisticComment = logisticComment;
    _this.returnable = returnable;
    _this.returnableCondition = returnableCondition;
    _this.endDateOfReturn = endDateOfReturn;
    _this.distrModelId = distrModelId;
    _this.lastDistrModelIdChangeTime = lastDistrModelIdChangeTime;
    _this.lastDistrModelIdChangeUser = lastDistrModelIdChangeUser;
    _this.distributionModelDays = distributionModelDays;
    _this.lockType = lockType;
    _this.selloutSales = selloutSales;
    _this.ignoreForTraining = ignoreForTraining;
    _this.activeSale = activeSale;
    _this.extraSaleSticker = extraSaleSticker;
    _this.tastings = tastings;
    _this.tvCommercial = tvCommercial;
    _this.groupOfSitesId = groupOfSitesId;
    _this.sitesData = sitesData;
    _this.onPicture = onPicture;
    _this.stateFlags = stateFlags;
    _this.classification = classification;
    _this.warningFlags = warningFlags;
    _this.substituteProductId = substituteProductId;
    _this.marketingComment = marketingComment;
    _this.directDelivery = directDelivery;
    _this.directDeliverySites = directDeliverySites;
    _this.measureUnits = measureUnits;
    _this.simulation = simulation;
    _this.justInTime = justInTime;
    _this.processed = processed;
    _this.lastPromoVolumeUpdate = lastPromoVolumeUpdate;
    _this.lastSystemVolumeComputationFailure = lastSystemVolumeComputationFailure;
    _this.forecastCoordinatorFlag = forecastCoordinatorFlag;
    _this.snapshotOriginId = snapshotOriginId;
    _this.source = source;
    return _this;
  }
  /**
   * Returns values of window attributes, that can be simulated.
   */


  _createClass(WindowItem, [{
    key: "getSimulationConflictValues",
    value: function getSimulationConflictValues() {
      return [this.regularPrice, this.promoPrice, this.promoVolume, this.posAttributes.posMarginImpactTheoretical, this.posAttributes.posMarginImpactExpected, this.posAttributes.posRedemption, this.posAttributes.posMechanics, this.posAttributes.posActionFlag, this.posAttributes.posType, this.cmForecast, this.systemVolume, this.requestSecondaryPlacement, this.onPicture, this.ignoreForTraining, this.activeSale, this.extraSaleSticker, this.tastings, this.tvCommercial, this.groupOfSitesId, this.marketingComment];
    }
    /**
     * LOG-7132 / added posMarginImpactExpected and posRedemption params
     *
     * If there is a simulation object the method returns new windows item with simulation object
     * attributes set to the original item. Simulation object itself is changed in the way that simulation
     * attributes are written to preferred* attributes.
     */

  }, {
    key: "applySimulation",
    value: function applySimulation() {
      var applyRejected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.simulation) {
        return this;
      }

      function getValue(a, b) {
        return a || b;
      }

      function getSimValue(a, b) {
        if (!utils_1.Utils.isNull(a) && (applyRejected || !applyRejected && !a.isRejected())) {
          return a.simulatedValue;
        }

        return b;
      }

      var posAttrs = this.posAttributes.copyMulti({
        posMarginImpactTheoretical: getSimValue(this.simulation.posMarginImpactTheoretical, this.posAttributes.posMarginImpactTheoretical),
        posMarginImpactExpected: getValue(this.simulation.posMarginImpactExpected, this.posAttributes.posMarginImpactExpected),
        posRedemption: getValue(this.simulation.posRedemption, this.posAttributes.posRedemption),
        posMechanics: getSimValue(this.simulation.posMechanics, this.posAttributes.posMechanics)
      });
      return this.copyMulti({
        regularPrice: getSimValue(this.simulation.regularPrice, this.regularPrice),
        promoPrice: getSimValue(this.simulation.promoPrice, this.promoPrice),
        promoVolume: getSimValue(this.simulation.promoVolume, this.promoVolume),
        posAttributes: posAttrs,
        simulation: this.simulation.applySimulation()
      });
    }
  }, {
    key: "getSimulation",
    value: function getSimulation() {
      if (!this.simulation) {
        throw new Error('Window ' + this.id + ' has no simulation object');
      }

      return this.simulation;
    }
  }, {
    key: "getRegularSales",
    value: function getRegularSales() {
      return this.regularPrice.mul(this.promoVolume);
    }
  }, {
    key: "getPromoSales",
    value: function getPromoSales() {
      return this.promoPrice.mul(this.promoVolume);
    }
  }, {
    key: "getPromoDiscount",
    value: function getPromoDiscount() {
      return this.regularPrice.minus(this.promoPrice).div(this.regularPrice.div(100)).floor();
    }
    /**
     * Calculates PromoPrice value for PromoOptAPI.
     *
     * Calculation differs based on WindowItem's POS Type. Formulas for each of POS Type may be find @LOG-3884
     */
    // https://jira.etnetera.cz/browse/LOG-3884

  }, {
    key: "getPromoPriceForPromoOpt",
    value: function getPromoPriceForPromoOpt() {
      switch (this.posAttributes.posType) {
        case PosTypeEnum_1.PosTypeEnum.MultiBuy:
          return this.calculateMultiBuyPromoPrice();

        case PosTypeEnum_1.PosTypeEnum.MultiBuyBetterPrice:
          return this.calculateMultiBuyBetterPricePromoPrice();

        case PosTypeEnum_1.PosTypeEnum.Gift:
          return this.calculateGiftPromoPrice();

        case PosTypeEnum_1.PosTypeEnum.Other:
          return this.calculateOtherPromoPrice();

        default:
          return this.promoPrice;
      }
    }
  }, {
    key: "isFCApprovalRequired",
    value: function isFCApprovalRequired() {
      return this.forecastCoordinatorFlag ? !this.forecastCoordinatorFlag.coordinatorAgreed : false;
    }
  }, {
    key: "calculateMultiBuyPromoPrice",
    value: function calculateMultiBuyPromoPrice() {
      var multiBuyVariant = this.posAttributes.posMultiBuyVariant;

      if (multiBuyVariant) {
        // parseMultiBuyVariant eg. 2 + 1 eq. [2, 1]
        var multiBuyVariantValues = WindowItemPosAttributes_1.WindowItemPosAttributes.parseMultiBuyVariant(multiBuyVariant);
        var multiBuyVariantSum = multiBuyVariantValues[0] + multiBuyVariantValues[1];
        return this.promoPrice.div(multiBuyVariantSum).times(big_decimal_1.bigdecimal(multiBuyVariant[0]));
      }

      return this.promoPrice;
    }
  }, {
    key: "calculateMultiBuyBetterPricePromoPrice",
    value: function calculateMultiBuyBetterPricePromoPrice() {
      var discountPerPiece = this.posAttributes.posDiscountPerPiece;

      if (discountPerPiece) {
        return this.promoPrice.minus(discountPerPiece);
      }

      return this.promoPrice;
    }
  }, {
    key: "calculateGiftPromoPrice",
    value: function calculateGiftPromoPrice() {
      var giftPrice = this.posAttributes.posGiftPrice;

      if (giftPrice) {
        return this.promoPrice.minus(giftPrice);
      }

      return this.promoPrice;
    }
  }, {
    key: "calculateOtherPromoPrice",
    value: function calculateOtherPromoPrice() {
      if (this.promoVolume.equals(big_decimal_1.bigdecimal(0))) {
        return this.promoPrice;
      }

      var calculatedPromoPrice = this.promoPrice.minus(this.posAttributes.posMarginImpactTheoretical.abs().div(this.promoVolume));

      if (calculatedPromoPrice.isNaN()) {
        return big_decimal_1.bigdecimal(0);
      }

      return calculatedPromoPrice;
    }
    /**
     * Used for situation when system volume must be defined.
     */

  }, {
    key: "getSafeSystemVolume",
    value: function getSafeSystemVolume() {
      if (utils_1.Utils.isNull(this.systemVolume)) {
        return big_decimal_1.bigdecimal(0.0);
      }

      return this.systemVolume;
    }
    /**
     * @returns value of "number of sites"
     */

  }, {
    key: "getNumberOfSites",
    value: function getNumberOfSites() {
      return this.sitesData.sites.size;
    }
  }, {
    key: "isCanceled",
    value: function isCanceled(promotion, window) {
      return window.isCanceled(promotion);
    }
  }, {
    key: "isPromoVolumeEditedByUser",
    value: function isPromoVolumeEditedByUser() {
      return utils_1.Utils.hasValue(this.lastPromoVolumeUpdate);
    }
    /**
     * Changes current window item by {@link WindowItemUpdateDTO}
     * @param dto DTO to apply
     * @param userInfo
     * @param daysToCoverDistrModelId
     */

  }, {
    key: "applyDTO",
    value: function applyDTO(dto, userInfo, daysToCoverDistrModelId) {
      var memberCredits = this.applyIfDefinedInDTO(this.memberCredits, dto.memberCredits);

      if (!memberCredits.enabled) {
        // Reset member credits to default state
        memberCredits = MemberCredits_1.MemberCredits.EMPTY;
      }

      return new WindowItem(this.id, this.productId, this.windowId, this.externalId, this.promotionId, this.applyIfDefinedInDTO(this.promoPrice, dto.promoPrice), this.applyIfDefinedInDTO(this.regularPrice, dto.regularPrice), this.optRegularPrice, this.applyIfDefinedInDTO(this.cmForecast, dto.cmForecast), this.applyIfDefinedInDTO(this.systemVolume, dto.systemVolume), // TODO ZSt check this
      this.applyIfDefinedInDTO(this.lastSystemVolumeUpdate, dto.lastSystemVolumeUpdate), this.applyIfDefinedInDTO(this.promoVolume, dto.promoVolume), this.applyIfDefinedInDTO(this.regularVolume, dto.regularVolume), this.applyIfDefinedInDTO(this.requestSecondaryPlacement, dto.requestSecondaryPlacement), this.applyIfDefinedInDTO(this.secondaryPlacement, dto.secondaryPlacement), this.applyIfDefinedInDTO(this.posAttributes, dto.posAttributes), memberCredits, this.applyIfDefinedInDTO(this.logisticComment, dto.logisticComment), this.applyIfDefinedInDTO(this.returnable, dto.returnable), this.applyIfDefinedInDTO(this.returnable, dto.returnable) ? this.applyIfDefinedInDTO(this.returnableCondition, dto.returnableCondition) : null, this.applyIfDefinedInDTO(this.returnable, dto.returnable) ? this.applyIfDefinedInDTO(this.endDateOfReturn, dto.endDateOfReturn) : null, this.applyIfDefinedInDTO(this.distrModelId, dto.distrModelId), dto.distrModelId && dto.distrModelId !== this.distrModelId ? moment() : this.lastDistrModelIdChangeTime, dto.distrModelId && dto.distrModelId !== this.distrModelId ? userInfo : this.lastDistrModelIdChangeUser, this.applyIfDefinedInDTO(this.distrModelId, dto.distrModelId) === daysToCoverDistrModelId ? this.applyIfDefinedInDTO(this.distributionModelDays, dto.distributionModelDays) : null, this.applyIfDefinedInDTO(this.lockType, dto.lockType), this.applyIfDefinedInDTO(this.selloutSales, dto.selloutSales), this.applyIfDefinedInDTO(this.ignoreForTraining, dto.ignoreForTraining), this.applyIfDefinedInDTO(this.activeSale, dto.activeSale), this.applyIfDefinedInDTO(this.extraSaleSticker, dto.extraSaleSticker), this.applyIfDefinedInDTO(this.tastings, dto.tastings), this.applyIfDefinedInDTO(this.tvCommercial, dto.tvCommercial), this.applyIfDefinedInDTO(this.groupOfSitesId, dto.groupOfSitesId), this.sitesData, this.applyIfDefinedInDTO(this.onPicture, dto.onPicture), this.stateFlags, this.classification, this.applyIfDefinedInDTO(this.warningFlags, dto.warningFlags), // TODO ZSt update flags from UI ???
      this.applyIfDefinedInDTO(this.substituteProductId, dto.substituteProductId), this.applyIfDefinedInDTO(this.marketingComment, dto.marketingComment), this.applyIfDefinedInDTO(this.directDelivery, dto.directDelivery), this.applyIfDefinedInDTO(this.directDelivery, dto.directDelivery) ? this.applyIfDefinedInDTO(this.directDeliverySites, dto.directDeliverySites) : null, this.applyIfDefinedInDTO(this.measureUnits, dto.measureUnits), this.applyIfDefinedInDTO(this.simulation, dto.simulation), utils_1.Utils.isValueMissing(dto.justInTime) ? this.justInTime : dto.justInTime, this.processed, this.applyIfDefinedInDTO(this.lastPromoVolumeUpdate, dto.lastPromoVolumeUpdate), this.applyIfDefinedInDTO(this.lastSystemVolumeComputationFailure, dto.lastSystemVolumeComputationFailure), this.applyIfDefinedInDTO(this.forecastCoordinatorFlag, dto.forecastCoordinatorFlag), this.snapshotOriginId, this.source);
    }
  }, {
    key: "applyIfDefinedInDTO",
    value: function applyIfDefinedInDTO(orig, dto) {
      return dto !== undefined ? dto : orig;
    }
    /**
     * Converter from data-dictionary representation
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new WindowItem(mat.id, mat.productId, mat.windowId, mat.externalId, mat.promotionId, mat.promoPrice, mat.regularPrice, mat.optRegularPrice, mat.cmForecast, mat.systemVolume, mat.lastSystemVolumeUpdate, mat.promoVolume, mat.regularVolume, mat.requestSecondaryPlacement, mat.secondaryPlacement, mat.posAttributes, mat.memberCredits, mat.logisticComment, mat.returnable, mat.returnableCondition, mat.endDateOfReturn, mat.distrModelId, mat.lastDistrModelIdChangeTime, mat.lastDistrModelIdChangeUser, mat.distributionModelDays, mat.lockType, mat.selloutSales, mat.ignoreForTraining, mat.activeSale, mat.extraSaleSticker, mat.tastings, mat.tvCommercial, mat.groupOfSitesId, mat.sitesData, mat.onPicture, mat.stateFlags, mat.classification, mat.warningFlags, mat.substituteProductId, mat.marketingComment, mat.directDelivery, mat.directDeliverySites, mat.measureUnits, mat.simulation, mat.justInTime, mat.processed, mat.lastPromoVolumeUpdate, mat.lastSystemVolumeComputationFailure, mat.forecastCoordinatorFlag, mat.snapshotOriginId, mat.source);
    }
    /**
     * Creates {@link WindowItem} external id for targeted system.
     *
     * @param promotionExtId The external ID of promotion
     * @param productExtId the external id of internal product
     * @returns created external id
     */

  }, {
    key: "windowItemExternalId",
    value: function windowItemExternalId(promotionExtId, productExtId) {
      var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils_1.Utils.EXTERNAL_ID_SEPARATOR;
      return [promotionExtId, productExtId].join(separator);
    }
    /**
     * Parse parts of window item external ID.
     * @param externalId window item external ID
     */

  }, {
    key: "parseWindowItemExternalId",
    value: function parseWindowItemExternalId(externalId) {
      var separatorIndex = externalId.indexOf(utils_1.Utils.EXTERNAL_ID_SEPARATOR);
      return {
        promotionId: externalId.substr(0, separatorIndex),
        productId: externalId.substr(separatorIndex + 1)
      };
    }
  }]);

  return WindowItem;
}(StateDomainObject_1.StateDomainObject);

exports.WindowItem = WindowItem;
WindowItem.DOCUMENT_TYPE = 'WindowItem';
WindowItem.EMPTY_LIST = immutable_1.List();

WindowItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItem.name);
  return {
    id: builder.id('id'),
    productId: builder.str('productId'),
    windowId: builder.str('windowId'),
    externalId: builder.str('externalId'),
    promotionId: builder.str('promotionId'),
    promoPrice: builder.bigNum('promoPrice'),
    regularPrice: builder.bigNum('regularPrice'),
    optRegularPrice: builder.opt(builder.bigNum('optRegularPrice')),
    cmForecast: builder.opt(builder.bigNum('cmForecast')),
    systemVolume: builder.opt(builder.bigNum('systemVolume')),
    lastSystemVolumeUpdate: builder.opt(builder.date('lastSystemVolumeUpdate', DateParser_1.DateParser.ISO_PATTERN)),
    promoVolume: builder.bigNum('promoVolume'),
    regularVolume: builder.opt(builder.bigNum('regularVolume')),
    requestSecondaryPlacement: builder.bool('requestSecondaryPlacement'),
    secondaryPlacement: builder.str('secondaryPlacement'),
    posAttributes: builder.obj('posAttributes', WindowItemPosAttributes_1.WindowItemPosAttributes.schema, WindowItemPosAttributes_1.WindowItemPosAttributes.fromMat),
    memberCredits: builder.obj('memberCredits', MemberCredits_1.MemberCredits.schema, MemberCredits_1.MemberCredits.fromMat),
    logisticComment: builder.opt(builder.trimStr('logisticComment', new StringLengthValidator_1.StringLengthValidator(1, 200)).withDescription({
      multiline: true
    })),
    returnable: builder.bool('returnable'),
    returnableCondition: builder.opt(builder.str('returnableCondition')),
    endDateOfReturn: builder.opt(builder.date('endDateOfReturn', DateParser_1.DateParser.ISO_PATTERN)),
    distrModelId: builder.lookup('distrModelId', CodebookLookupSequence_1.CodebookLookupSequence.DistributionModel),
    lastDistrModelIdChangeTime: builder.opt(builder.date('lastDistrModelIdChangeTime', DateParser_1.DateParser.ISO_PATTERN)),
    lastDistrModelIdChangeUser: builder.opt(builder.obj('lastDistrModelIdChangeUser', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })),
    distributionModelDays: builder.opt(builder.num('distributionModelDays')),
    lockType: builder.senum('lockType', LockTypeEnum_1.LockTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.LockType),
    selloutSales: builder.bool('selloutSales'),
    ignoreForTraining: builder.bool('ignoreForTraining'),
    activeSale: builder.bool('activeSale'),
    extraSaleSticker: builder.bool('extraSaleSticker'),
    tastings: builder.bool('tastings'),
    tvCommercial: builder.bool('tvCommercial'),
    groupOfSitesId: builder.str('groupOfSitesId'),
    sitesData: builder.obj('sitesData', WindowItemSitesData_1.WindowItemSitesData.schema, function (mat) {
      return WindowItemSitesData_1.WindowItemSitesData.fromDataDict(mat);
    }),
    onPicture: builder.bool('onPicture'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: WindowItem.name + '_classification'
    })),
    warningFlags: builder.flags('warningFlags', WindowItemWarningFlag_1.WindowItemWarningFlag),
    substituteProductId: builder.opt(builder.str('substituteProductId')),
    marketingComment: builder.opt(builder.trimStr('marketingComment')),
    directDelivery: builder.bool('directDelivery'),
    directDeliverySites: builder.opt(builder.str('directDeliverySites')),
    measureUnits: builder.opt(builder.str('measureUnits')),
    simulation: builder.opt(builder.obj('simulation', WindowItemSimulation_1.WindowItemSimulation.schema, function (mat) {
      return WindowItemSimulation_1.WindowItemSimulation.fromDataDict(mat);
    })),
    justInTime: builder.bool('justInTime'),
    processed: builder.bool('processed'),
    lastPromoVolumeUpdate: builder.opt(builder.date('lastPromoVolumeUpdate', DateParser_1.DateParser.ISO_PATTERN)),
    lastSystemVolumeComputationFailure: builder.opt(builder.date('lastSystemVolumeComputationFailure', DateParser_1.DateParser.ISO_PATTERN)),
    forecastCoordinatorFlag: builder.opt(builder.obj('forecastCoordinatorFlag', CoordinatorFlags_1.CoordinatorFlags.schema, function (mat) {
      return CoordinatorFlags_1.CoordinatorFlags.fromDataDict(mat);
    })),
    snapshotOriginId: builder.opt(builder.str('snapshotOriginId')),
    source: builder.opt(builder.senum('source', CreationSource_1.CreationSource, CodebookLookupSequence_1.CodebookLookupSequence.CreationSource))
  };
}();